module.exports = __webpack_public_path__ + "img/pencil-edit-button.14b49c41.svg";